import React, { useEffect, useState } from 'react';
import { Image, Spin } from 'antd';
import { YoutubeOutlined, LoadingOutlined } from '@ant-design/icons';

// Helper: get standard YT thumbnail for videos
const getStandardYouTubeThumbnail = (input: string): string | null => {
  if (!input) return null;
  let videoId: string | null = null;

  try {
    const urlObj = new URL(input);
    if (urlObj.hostname.includes('youtube.com')) {
      if (urlObj.pathname === '/watch') {
        videoId = urlObj.searchParams.get('v');
      } else if (urlObj.pathname.startsWith('/shorts/')) {
        const segments = urlObj.pathname.split('/').filter(Boolean);
        videoId = segments.length > 1 ? segments[1] : null;
      }
    } else if (urlObj.hostname === 'youtu.be') {
      videoId = urlObj.pathname.slice(1);
    }
  } catch {
    videoId = input; // assume it's a video ID
  }

  return videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : null;
};

const makeYoutubeLink = (input: string): string => {
  if (input.includes('youtube.com/clip/')) return input;
  return `https://www.youtube.com/watch?v=${input}`;
};

const UserVideo = ({ video }: { video: string }) => {
  const [thumbnailUrl, setThumbnailUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);

    if (video.includes('youtube.com/clip/')) {
      // Just extract the unique clip ID
      const match = video.match(/\/clip\/([a-zA-Z0-9_-]+)/);
      setThumbnailUrl(match ? match[1] : video);
    } else {
      setThumbnailUrl(getStandardYouTubeThumbnail(video));
    }

    setIsLoading(false);
  }, [video]);

  return (
    <a
      href={makeYoutubeLink(video)}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', maxWidth: '320px', margin: '0 auto' }}
    >
      <div
        style={{
          width: '100%',
          aspectRatio: '16/9',
          borderRadius: '8px',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f0f0f0',
        }}
      >
        {isLoading ? (
          <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
        ) : thumbnailUrl ? (
          video.includes('youtube.com/clip/') ? (
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#000',
                color: '#fff',
                fontWeight: 'bold',
                fontSize: '1.2rem',
              }}
            >
              {thumbnailUrl}
            </div>
          ) : (
            <Image
              src={thumbnailUrl}
              alt="YouTube video"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              preview={false}
            />
          )
        ) : (
          <YoutubeOutlined style={{ fontSize: '48px', color: '#ff0000' }} />
        )}
      </div>
    </a>
  );
};

export default UserVideo;
